"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventType_1 = require("../../model/types/EventType");
var AbstractEvent_1 = require("./AbstractEvent");
var UserCreatedEvent = (function (_super) {
    __extends(UserCreatedEvent, _super);
    function UserCreatedEvent() {
        return _super.call(this) || this;
    }
    UserCreatedEvent.prototype.getType = function () {
        return EventType_1.EventType.UserCreated;
    };
    return UserCreatedEvent;
}(AbstractEvent_1.AbstractEvent));
exports.UserCreatedEvent = UserCreatedEvent;
//# sourceMappingURL=UserCreatedEvent.js.map